import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { EDIT_STATE_OPTIONS_PAGE_ROUTE } from '../../../utils/constants'
import { StateSettingsHeader } from './components/state-settings-header/StateSettingsHeader'
import { StateSettingsBody } from './components/state-settings-body/StateSettingsBody'
import { useStateSettings } from './hooks/useStateSettings'

export const StatesSettings = () => {
  const navigate = useNavigate()

  const { settingsPerState } = useStateSettings()

  useEffect(() => {
    // Clear any legacy edit-state callback from prior page visits
    window.onEditState = null
  }, [])

  const selectState = (stateToEdit: string) => {
    navigate(`${EDIT_STATE_OPTIONS_PAGE_ROUTE}?state=${stateToEdit}`, {
      state: {
        search: location.search,
      },
    })
  }

  return (
    // Match the other management tabs (ClinicMembers / ServiceTypes): no own background, so the
    // content sits on the single management page background (--app-background). Previously this
    // forced bg-deep-navy-5 (#F6F7F8), which differs from the page's #eceff1 and left a visible
    // two-tone seam (a lighter strip beside the content-container's left padding).
    <div className='flex flex-auto flex-col'>
      <StateSettingsHeader />
      <StateSettingsBody stateSettingsList={settingsPerState} onSelectState={selectState} />
    </div>
  )
}
